/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BackupHistoryDto } from '../models/BackupHistoryDto';
import type { RestoreDto } from '../models/RestoreDto';
import type { RestoreHistoryDto } from '../models/RestoreHistoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantRestoreControllerService {

    /**
     * @deprecated
     * @param name
     * @returns RestoreDto OK
     * @throws ApiError
     */
    public static getParticipantRestoreSchedule(
        name: string,
    ): CancelablePromise<RestoreDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/restore',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @deprecated
     * @param name
     * @param requestBody
     * @returns RestoreDto Created
     * @throws ApiError
     */
    public static createParticipantRestoreSchedule(
        name: string,
        requestBody: RestoreDto,
    ): CancelablePromise<RestoreDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participants/{name}/restore',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @deprecated
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteParticipantRestoreSchedule(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/participants/{name}/restore',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @deprecated
     * @param name
     * @returns BackupHistoryDto OK
     * @throws ApiError
     */
    public static getParticipantRestoreFiles(
        name: string,
    ): CancelablePromise<Array<BackupHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/restore/listFiles',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @deprecated
     * @param name
     * @returns RestoreHistoryDto OK
     * @throws ApiError
     */
    public static getParticipantRestoreHistory(
        name: string,
    ): CancelablePromise<Array<RestoreHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/restore/history',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
